import { Outlet } from 'react-router-dom';
import { AuthProvider } from './auth/AuthContext';
import { OrgProvider } from './tenancy/OrgContext';
import { ThemeProvider } from './theme/ThemeContext';
import { EstimateModeProvider } from './estimate/EstimateModeContext';
import { ConfirmProvider } from './components/ConfirmDialog';

export default function App() {
  return (
    <ThemeProvider>
      <EstimateModeProvider>
        <ConfirmProvider>
          <AuthProvider>
            <OrgProvider>
              <Outlet />
            </OrgProvider>
          </AuthProvider>
        </ConfirmProvider>
      </EstimateModeProvider>
    </ThemeProvider>
  );
}
